module.exports = __webpack_public_path__ + "img/LC3.341c467a.svg";